<template>
    <div class="mt-3">
        <label>Email me the link:</label>
        <input v-model="email" type="email" placeholder="Enter your email">
        <a class="btn btn-secondary" @click="submitEmail">Submit</a>
    </div>
</template>

<script>
export default {
    props: {
        apiEndpoint: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            email: '',
        };
    },
    methods: {
        submitEmail() {
            axios.post(this.apiEndpoint, { email: this.email })
                .then(response => {
                    if(response.data.success) {
                        notyf.open({
                            type: 'success',
                            message: 'Email sent!',
                        });
                    } else {
                        notyf.open({
                            type: 'error',
                            message: 'Email could not be sent.',
                        });
                    }
                })
                .catch(error => {
                    console.error('Error submitting email', error);
                });
        },
    },
};
</script>

<style scoped>
 input {
     width: 350px;
 }
</style>

